import React, { useState, useRef } from "react";
import { CircularProgressCustom } from "./common-components/CircularProgressCustom";
import { useQuery } from "@apollo/react-hooks";
import { GET_CASE_STUDIES } from "./../../services/graphql-query";
import { Container, Row, Col } from "react-bootstrap";
import { apiUrl } from "./../../services/constants";
import { AiOutlineRight } from "react-icons/ai";
import { FaFileDownload } from "react-icons/fa";
import EmailButton from "./../assets/icons/Emailbutton.svg";
import { Modal, Button } from "react-bootstrap";
import { saveAs } from "file-saver";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import { Backdrop, CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import "../../css/app.css";

const CaseStudies = () => {
    const { loading, error, data } = useQuery(GET_CASE_STUDIES);
    const [isReadMore, setReadMore] = useState(false);
    const [isKey, setKey] = useState(false);
    const [isShow, setShow] = useState(false);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [email, setEmail] = useState("");
    const [token, setToken] = useState(null);
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const captchaRef = useRef(null);
    const [isCaseStudy, setCaseStudy] = useState({});

    const onReadMore = index => {
        setReadMore(true);
        setKey(index);
    };

    const onReadLess = index => {
        setReadMore(false);
        setKey(index);
    };

    const onClickDownload = () => {
        const content = "Hello, world!";
        // console.log(content.base64);
        // var blob = new Blob([content.base64()], {
        //     type: "application/pdf"
        // });
        // console.log(blob);
        // saveAs(blob, "hello world.pdf");
    };

    const onClickEmail = item => {
        setShow(true);
        setCaseStudy(item);
    };

    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };

    const handleEmailSend = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                caseStudyLocation: isCaseStudy.attributes.Location_Case_Study,
                caseStudyTitle: isCaseStudy.attributes.Title_Case_Study,
                caseStudyContent: isCaseStudy.attributes.Content_Case_Study,
                caseStudyImage:
                    apiUrl + isCaseStudy.attributes.Image.data.attributes.url,
                pdfFile:
                    apiUrl + isCaseStudy.attributes.PDFFileForEmailSend.data.attributes.url,
            })
        };

        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            setIsOpenBackdrop(true);
            fetch(`/api/casestudy/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setCaseStudy({});
                    setToken(null);
                    setIsOpenBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success");
                    } else {
                        Swal.fire("Oops...", result.msg, "error");
                    }
                });
        }
    };

    if (loading) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    return (
        <Container className="case-studies-container">
            <Row>
                {data.caseStudies.data.map((item, key) => (
                    <Col md={6} key={key}>
                        <img
                            src={
                                apiUrl +
                                item.attributes?.Image?.data?.attributes?.url
                            }
                            alt={item.attributes?.Image?.data?.attributes?.name}
                            width="100%"
                            style={{ border: "1px solid #a7a7a7" }}
                        />
                        <div className="csas-study-content">
                            <div className="case-study-header">
                                <h4>{item.attributes?.Title_Case_Study}</h4>
                                <p>{item.attributes?.Location_Case_Study}</p>
                            </div>
                            <div className="case-study-body">
                                {isReadMore && key === isKey
                                    ? item.attributes?.Content_Case_Study.split(
                                        "**"
                                    ).map((item, key) => {
                                        if (key % 2 === 1) {
                                            return <b key={key}>{item}</b>;
                                        } else {
                                            return item;
                                        }
                                    })
                                    : item.attributes?.Content_Case_Study.replace(
                                        /\*\*/gi,
                                        ""
                                    ).slice(0, 200)}
                                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                                    {isReadMore && key === isKey ? (
                                        <div
                                            className="d-flex flex-row align-items-center case-studies-more"
                                            onClick={() => onReadLess(key)}
                                        >
                                            Read Less <AiOutlineRight />
                                        </div>
                                    ) : (
                                        <div
                                            className="d-flex flex-row align-items-center case-studies-more"
                                            onClick={() => onReadMore(key)}
                                        >
                                            Read More <AiOutlineRight />
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center">
                                        {/* <div
                                            className="case-study-items"
                                            onClick={() =>
                                                onClickDownload(item)
                                            }
                                        >
                                            <FaFileDownload />
                                        </div> */}
                                        <div
                                            className="case-study-items"
                                            onClick={() => onClickEmail(item)}
                                        >
                                            <img
                                                className="share-email-button"
                                                src={EmailButton}
                                            />
                                        </div>
                                        <div className="case-study-items">
                                            Comments Off
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isShow}
                onHide={() => setShow(false)}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="exampleModalLabel">
                        Case Study
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <input
                        name="email"
                        type="email"
                        className={`form-control ${isEmailError
                                ? "is-invalid"
                                : isClicked && "is-valid"
                            }`}
                        id="floatingInput"
                        placeholder="name@gmail.com"
                        // defaultValue={email}
                        onChange={e => {
                            setEmail(e.target.value);
                        }}
                    />
                    <label htmlFor="floatingInput">Email address</label>
                    {isEmailError ? (
                        <div className="invalid-feedback">
                            Please enter a valid email.
                        </div>
                    ) : (
                        isClicked && (
                            <div className="valid-feedback">Looks good!</div>
                        )
                    )}
                    <div className="mt-2">
                        <HCaptcha
                            ref={captchaRef}
                            sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                            onVerify={token => handleVerificationSuccess(token)}
                            onExpire={() => setIsCaptchaExpired(true)}
                        />
                    </div>
                    {!token && isClicked ? (
                        <p className="text-danger">
                            This is hCaptcha for human testing.
                        </p>
                    ) : (
                        isCaptchaExpired && (
                            <p className="text-danger">
                                The hCaptcha for human testing has expired.
                            </p>
                        )
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => setShow(false)}
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        id="closeModal"
                    >
                        Close
                    </Button>
                    <Button
                        onClick={handleEmailSend}
                        type="submit"
                        className="btn btn-dark"
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: theme => theme.zIndex.drawer + 1
                }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    );
};

export default CaseStudies;
